import { useEmbeddedAuth } from '@src/contexts/embedded-auth/useEmbeddedAuth';
import { Permission } from '@repo/types';
import { useGetUser } from '@src/api/useUser';

export function useHasPermission() {
  const { isAuthenticated } = useEmbeddedAuth();
  const { data: user } = useGetUser(isAuthenticated);
  const hasPermissionFn = (permission: Permission) =>
    user?.affiliations?.some(
      (affiliation) =>
        affiliation.status === 'approved' &&
        affiliation.permissions.includes(permission)
    );

  const hasOnePermission = (permissions: Permission[]) =>
    permissions.some((permission) => hasPermissionFn(permission));

  return {
    hasPermission: hasPermissionFn,
    hasOnePermission,
  };
}
